module.exports = __webpack_public_path__ + "static/scale-model-of-seattle-chocolate-in-renton-washington-2c45a8962d61c0230cc2a2674f721867.png";